export default "__VITE_ASSET__D46$pw3T__"